import { createFileRoute } from '@tanstack/react-router';
import { useState, type ReactElement } from 'react';
import { useViewport } from '@/lib/hooks/use-viewport';
import { DAdminShell } from '@/components/organisms/admin-shell';
import { AdminDesktopOnlyNotice } from '@/components/organisms/admin-desktop-only-notice';
import { ReferenceTakeQueuePane } from '@/components/organisms/reference-take-queue-pane';
import { useReferenceTakeCandidates } from '@/lib/queries/reference-take-moderation';

const PAGE_SIZE = 20;

function QueueCentrePlaceholder(): ReactElement {
  return (
    <div className="flex-1 flex items-center justify-center px-8 py-12 text-center">
      <p className="text-[13px] text-[var(--ink-3)] max-w-[320px]">
        Select a contribution from the queue to begin reviewing.
      </p>
    </div>
  );
}

function AdminReferenceTakesPage(): ReactElement {
  const viewport = useViewport();
  const [page, setPage] = useState(0);
  if (viewport !== 'desktop') return <AdminDesktopOnlyNotice />;
  const { data, isLoading } = useReferenceTakeCandidates({ page, size: PAGE_SIZE });
  const subtitle = data ? `${data.totalElements.toLocaleString()} pending` : '…';
  return (
    <DAdminShell section="reference-takes" title="Reference takes" subtitle={subtitle}>
      <div className="grid grid-cols-[280px_1fr] h-full">
        <ReferenceTakeQueuePane
          page={data}
          isLoading={isLoading}
          currentPage={page}
          onPageChange={setPage}
        />
        <QueueCentrePlaceholder />
      </div>
    </DAdminShell>
  );
}

export const Route = createFileRoute('/admin/reference-takes/')({
  component: AdminReferenceTakesPage,
});
